import Component from '../../../components/Component';

import keys from './keys';
import query from './query';
import ListData from '../../../components/ListData';
import { withTranslation } from 'react-i18next';

class Summary extends Component {
    constructor() {
        super();
        this.query = query;
    }
    render() {
        const { t } = this.props;

        return (
            <ListData
                loading={this.state.loading}
                header={this.props.header ?? t('search.overview.topPages.summaryList.topPages')}
                subheader={
                    this.props.subheader ?? t('search.overview.topPages.summaryList.byClicks')
                }
                forceRun={this.forceRun}
                link={`/domains/${this.props.domain_id}/gsc-reports/urls`}
                keys={keys(t)}
                uniqKey="level"
                data={this.state.data}
                cardClassName={'list-data-full'}
            />
        );
    }
}

export default withTranslation()(Summary);
